import { FunctionalComponent, h } from '@stencil/core';
import { isPageVisible } from '../dot-navigation.utils';
import { FAR_DOT, FARTHER_DOT } from '../dot-navigation.constants';

interface DotElementProps {
  key: number;
  transitionPage: number;
  pages: number;
  dotElementAriaLabel: string;
}

export const DotElement: FunctionalComponent<DotElementProps> = ({ key, transitionPage, pages, dotElementAriaLabel }) => {
  const isDotVisible = isPageVisible(key, transitionPage);
  const isDotActive = key === transitionPage;
  const isDotFar = key === transitionPage - FAR_DOT || key === transitionPage + FAR_DOT;
  const isDotFarther = key === transitionPage - FARTHER_DOT || key === transitionPage + FARTHER_DOT;
  const ariaLabel = dotElementAriaLabel.replace(/:page/g, String(key)).replace(/:size/g, String(pages));

  return (
    <button //
      role="tab"
      aria-selected={isDotActive ? 'true' : 'false'}
      aria-setsize={pages}
      aria-posinset={key}
      aria-label={ariaLabel}
      tabindex={isDotActive ? 0 : -1}
      type="button"
      class={{ dot: true, visible: isDotVisible, active: isDotActive, far: isDotFar, farther: isDotFarther }}
    />
  );
};
